module.exports = __webpack_public_path__ + "static/media/logo-white.be09df69.png";